import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, Input, Output, EventEmitter, ViewChildren, ViewChild, QueryList } from "@angular/core";
import { SplitComponent, SplitAreaDirective } from 'angular-split'
import { delay, SharedService } from '../../../shared'
import { ResearchCard, CannabisOption } from '../../shared'
import Grid from 'tui-grid';

enum TabsEnum {
    RESULTS = 'RESULTS',
    SELECTED = 'SELECTED'
}

enum SwitchEnum {
    AND = 'AND',
    OR = 'OR'
}

@Component({
    selector: 'app-research-popup',
    templateUrl: "./research-popup.component.html",
    styleUrls: ["./research-popup.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class ResearchPopupComponent implements OnInit {
    @ViewChild("summarySplitter", { static: false }) summarySplitter: SplitComponent;
    @ViewChild("mainSplitter", { static: true }) mainSplitter: SplitComponent;
    @ViewChildren(SplitAreaDirective) areasEl: QueryList<SplitAreaDirective>;

    @Input() partnerName: string = "";
    @Input() researchCards: ResearchCard[] = [];
    @Input() suggestedOptions: CannabisOption[] = [];

    @Output() updateJsPanelTitle = new EventEmitter();

    showLoader: boolean = false;
    offset: number = 0;
    showBufferButton: boolean = false;

    queryName: string = "PubMed Literatur Recherche";
    searchQuery: string = "";
    allResearchData: any[] = [];
    researchData: any[] = [];
    researchGrid: Grid;

    TabsEnum = TabsEnum;
    selectedTab: TabsEnum = TabsEnum.RESULTS;

    SwitchEnum = SwitchEnum;
    selectedSwitch: SwitchEnum = SwitchEnum.AND;

    summaryRowData: any = null;

    chartTooltip: any = {};

    showPublications: boolean = true;
    showKeywords: boolean = true;

    keywordFilterArray: string[] = [];
    keywordChartData: any[] = [];

    publicationFilterArray: string[] = [];
    publicationChartData: any[] = [];

    get jsPanelContentHeight() {
        if (document.getElementsByClassName("jsPanel-content").length) {
            return document.getElementsByClassName("jsPanel-content")[0].clientHeight;
        }
        else {
            return document.body.clientHeight;
        }
    }

    get chartContainerHeight() {
        return this.jsPanelContentHeight - 20;
    }

    get researchTopContent() {
        if (document.getElementById("research-top-section")) {
            return document.getElementById("research-top-section").clientHeight;
        } else {
            return 100;
        }
    }

    get cardBodyHeight() {
        return this.jsPanelContentHeight - this.researchTopContent - 75;
    }

    get gridBodyHeight() {
        return this.cardBodyHeight - 40;
    }

    constructor(private cd: ChangeDetectorRef,
        private sharedService: SharedService) {
    }

    ngOnInit(): void {
        this.updateJsPanelTitle.emit(this.queryName);
        const defaultOption: CannabisOption = { Label: "Cannabis" };
        this.suggestedOptions = [defaultOption, ...this.suggestedOptions];
        for (var i = 0; i < this.suggestedOptions.length; i++) {
            let option = this.suggestedOptions[i];
            option.Selected = true;
            this.bindToQuery(option);
        }
        this.initializeGrid();
        this.fetchAPIData();
        this.windowEvents();
        this.bindMainSplitterFn();
    }

    windowEvents() {
        window["viewSummaryText"] = (rowKey) => {
            this.fnViewSummaryText(rowKey);
        }

        window["onkeydown"] = (e) => {
            if (!this.checkGridActive()) {
                return;
            }
            const focused = this.researchGrid.getFocusedCell();
            const row = this.researchGrid.getRow(focused.rowKey);

            if (e.keyCode == '38') {
                // up arrow
                if (!row && this.researchGrid.getData().length > 0) {
                    this.researchGrid.focus(0, "title");
                }
                if (!row) {
                    return;
                }
                if (this.summaryRowData) {
                    this.fnViewSummaryText(focused.rowKey);
                }
            }
            else if (e.keyCode == '40') {
                // down arrow
                if (!row && this.researchGrid.getData().length > 0) {
                    this.researchGrid.focus(0, "title");
                }
                if (!row) {
                    return;
                }
                if (this.summaryRowData) {
                    this.fnViewSummaryText(focused.rowKey);
                }
            }
            else if (e.keyCode == '37') {
                // left arrow
                this.fnHideSummaryText();
            }
            else if (e.keyCode == '39') {
                // right arrow
                if (!row) {
                    return;
                }
                this.fnViewSummaryText(focused.rowKey);
            }
            else if (e.keyCode == '32') {
                // space
                if (!row) {
                    return;
                }
                if (row._attributes.checked) {
                    this.researchGrid.uncheck(focused.rowKey);
                } else {
                    this.researchGrid.check(focused.rowKey);
                }
            }
        }
    }

    async fnHideSummaryText() {
        this.summaryRowData = null;
        await delay(1);
        this.fnUpdateResearchGrid();
    }

    fnViewSummaryText(rowKey) {
        var allData = this.researchGrid.getData();
        var rowData = allData.find(a => a.rowKey == rowKey);
        this.summaryRowData = rowData;
        this.bindSummarySplitFn();
    }

    checkGridActive() {
        let isActive = false;
        if (this.selectedTab === TabsEnum.RESULTS && !this.showLoader) {
            isActive = true;
        }
        return isActive;
    }

    async bindMainSplitterFn() {
        this.mainSplitter.dragProgress$.subscribe(res => {
            this.fnUpdateResearchGrid();
        })
    }

    async bindSummarySplitFn() {
        this.summarySplitter.dragProgress$.subscribe(res => {
            this.fnUpdateResearchGrid();
        })
        await delay(1);
        this.fnUpdateResearchGrid();
    }


    bindToQuery(option: CannabisOption) {
        let index = this.searchQuery.indexOf(option.Label);
        if (option.Selected && index > -1) {
            option.Selected = false;
            this.searchQuery = this.searchQuery.replace(option.Label, "");
        } else {
            option.Selected = true;
            this.searchQuery = this.searchQuery.length ? `${this.searchQuery} ${option.Label}` : `${option.Label}`;
        }
    }

    fnChangeSearchQuery() {
        for (var i = 0; i < this.suggestedOptions.length; i++) {
            let option = this.suggestedOptions[i];
            let index = this.searchQuery.indexOf(option.Label);
            if (index > -1) {
                option.Selected = true;
            } else {
                option.Selected = false;
            }
        }
    }

    fnUpdateJsPanelTitle() {
        this.updateJsPanelTitle.emit(this.queryName);
    }

    fnAddToKeywordFilter(value) {
        if (this.selectedTab === TabsEnum.SELECTED || !this.allResearchData.length) {
            return;
        }
        if (this.keywordFilterArray.indexOf(value) == -1) {
            this.keywordFilterArray.push(value);
            this.cd.detectChanges();
            this.fnUpdateResearchData();
        }
    }

    fnRemoveToKeywordFilter(index) {
        if (this.selectedTab === TabsEnum.SELECTED || !this.allResearchData.length) {
            return;
        }
        this.keywordFilterArray.splice(index, 1);
        this.cd.detectChanges();
        this.fnUpdateResearchData();
    }

    fnAddToPublicationFilter(value) {
        if (this.selectedTab === TabsEnum.SELECTED || !this.allResearchData.length) {
            return;
        }
        if (this.publicationFilterArray.indexOf(value) == -1) {
            this.publicationFilterArray.push(value);
            this.cd.detectChanges();
            this.fnUpdateResearchData();
        }
    }

    fnRemoveToPublicationFilter(index) {
        if (this.selectedTab === TabsEnum.SELECTED || !this.allResearchData.length) {
            return;
        }
        this.publicationFilterArray.splice(index, 1);
        this.cd.detectChanges();
        this.fnUpdateResearchData();
    }

    fnSwitchToggle() {
        if (this.selectedTab === TabsEnum.SELECTED || !this.allResearchData.length) {
            return;
        }
        if (this.selectedSwitch === SwitchEnum.AND) {
            this.selectedSwitch = SwitchEnum.OR;
        } else {
            this.selectedSwitch = SwitchEnum.AND;
        }
        this.fnUpdateResearchData();
    }

    fetchAPIData() {
        if (this.showLoader) {
            return;
        }
        this.showLoader = true;
        this.keywordFilterArray = [];
        this.publicationFilterArray = [];
        this.allResearchData = [];
        this.researchData = [];
        this.offset = 0;
        //if (!this.searchQuery.length) {
        //    this.fnUpdateResearchData();
        //    return;
        //}
        this.fnGetResearchData(false);
    }

    fnLoadNextBufferData() {
        this.offset += 200;
        this.fnGetResearchData(true);
    }

    fnGetResearchData(buffer) {
        this.showLoader = true;
        this.sharedService.getResearchData(this.offset, this.searchQuery).subscribe(
            res => {
                this.researchData = res || [];
                this.allResearchData = [...this.allResearchData, ...this.researchData];
                this.fnUpdateResearchData(buffer);
            },
            err => {
                if (this.offset >= 200) {
                    this.offset -= 200;
                }
                this.researchData = [];
                this.allResearchData = [...this.allResearchData, ...this.researchData];
                this.fnUpdateResearchData(buffer);
            }
        )
    }

    getFilteredData(researchData) {
        researchData = researchData || [];
        const records = [...researchData];
        let data = [];
        if (this.selectedSwitch === SwitchEnum.AND) {
            data = [...researchData];
            this.keywordFilterArray.forEach(item => {
                const matched = data.filter(a => a.keywords.indexOf(item) >= 0 || a.mesh_terms.indexOf(item) >= 0);
                data = [...matched];
            })
            this.publicationFilterArray.forEach(item => {
                const matched = data.filter(a => a.publication_types.indexOf(item) >= 0);
                data = [...matched];
            })
        } else {
            this.keywordFilterArray.forEach(item => {
                const matched = records.filter(a => a.keywords.indexOf(item) >= 0 || a.mesh_terms.indexOf(item) >= 0);
                matched.forEach(b => {
                    if (data.indexOf(c => c.id == b.id) == -1) {
                        data.push(b);
                    }
                })
            })
            this.publicationFilterArray.forEach(item => {
                const matched = records.filter(a => a.publication_types.indexOf(item) >= 0);
                matched.forEach(b => {
                    if (data.indexOf(c => c.id == b.id) == -1) {
                        data.push(b);
                    }
                })
            })
        }
        return data;
    }

    fnUpdateResearchData(buffer = false) {
        if (this.researchGrid) {
            this.fnUpdateResearchGrid(true, buffer);
        } else {
            this.initializeGrid();
        }
        this.showLoader = false;
        this.fnStatisticsChart();
    }

    fnUpdateResearchGrid(resetData = false, buffer = false) {
        if (this.researchGrid && this.selectedTab === TabsEnum.RESULTS) {
            const focused = this.researchGrid.getFocusedCell();
            this.researchGrid.setBodyHeight(this.gridBodyHeight);
            if (resetData) {
                if (buffer) {
                    this.researchGrid.appendRows(this.getFilteredData(this.researchData));
                    this.refreshGrid(false);
                } else {
                    this.researchGrid.resetData(this.getFilteredData(this.allResearchData));
                }
            }
            this.researchGrid.refreshLayout();
            this.updateGridValues(focused);
        }
    }

    async refreshGrid(showButton) {
        if (!(this.researchGrid && this.selectedTab === TabsEnum.RESULTS)) {
            return;
        }
        if (!showButton) {
            this.showBufferButton = false;
            await delay(1);
        }
        this.researchGrid.setBodyHeight(this.gridBodyHeight - (showButton ? 42 : 0));
        this.researchGrid.refreshLayout();
        if (showButton) {
            await delay(1);
            this.showBufferButton = true;
        }

    }

    updateGridValues(focused) {
        if (focused && focused.rowKey >= 0) {
            this.researchGrid.focus(focused.rowKey, "title", true);
        }
        //this.researchGrid.uncheckAll();
        this.updateGridCheckbox();
    }

    fnTabChange(tab: TabsEnum) {
        this.selectedTab = tab;
        this.cd.detectChanges();
        switch (tab) {
            case TabsEnum.RESULTS:
                this.initializeGrid();
                break;
            case TabsEnum.SELECTED:
                this.summaryRowData = null;
                break;
            default:
                break;
        }
        this.fnStatisticsChart();
    }

    async initializeGrid() {
        await delay(100);
        let component = this;
        if (component.selectedTab === TabsEnum.RESULTS) {
            this.researchGrid = new Grid({
                el: document.getElementById('researchGrid'), // Container element
                data: component.getFilteredData(component.allResearchData),
                rowHeaders: ['checkbox'],
                bodyHeight: component.gridBodyHeight,
                //rowHeight: 'auto',
                header: {
                    align: 'left',
                    columns: [
                        {
                            name: 'abstract',
                            align: 'center'
                        }
                    ]
                },
                columnOptions: {
                    resizable: true
                },
                columns: [
                    {
                        header: 'Title',
                        name: 'title',
                        align: "left",
                        filter: 'text',
                        //whiteSpace: 'normal',
                        formatter: function (props) {
                            return props.value ? `<span title="${props.value}">${props.value}</span>` : "";
                        },
                        sortable: true
                    },
                    {
                        header: 'Date',
                        name: 'date',
                        width: 90,
                        align: "left",
                        filter: 'text',
                        //whiteSpace: 'normal',
                        formatter: function (props) {
                            return props.value ? `<span title="${props.value}">${props.value}</span>` : "";
                        },
                        sortable: true
                    },
                    {
                        header: 'URL',
                        name: 'url',
                        align: "left",
                        filter: 'text',
                        //whiteSpace: 'normal',
                        formatter: function (props) {
                            return props.value ? `<a href="${props.value}" target="_blank" title="${props.value}">${props.value}</a>` : "";
                        },
                        sortable: true
                    },
                    {
                        header: 'Summary',
                        name: 'abstract',
                        width: 85,
                        align: 'center',
                        filter: 'text',
                        sortable: false,
                        resizable: false,
                        formatter: function (props) {
                            return `<button type="button" class="btn btn-sm" style="line-height: 1;padding: 2px 5px;" onclick="window.viewSummaryText(${props.row.rowKey})">
                                        <img src="/view.svg" style="width:16px;" alt="View" />
                                    </button>`;
                        }
                    }
                ]
            });
            this.updateGridCheckbox();

            this.researchGrid.on("click", (data) => {
                this.fnViewSummaryText(data["rowKey"]);
            })

            this.researchGrid.on("check", (data) => {
                this.updateResearchCardOnCheck(data, true);
            })

            this.researchGrid.on("uncheck", (data) => {
                this.updateResearchCardOnCheck(data, false);
            })

            this.researchGrid.on('scrollEnd', () => {
                this.refreshGrid(true);
            })

            this.researchGrid.activateFocus();

            Grid.applyTheme('striped');


            jQuery(".tui-grid-body-area").on("scroll", function () {
                var scrollTop = jQuery(this).scrollTop();
                var height = jQuery(this).innerHeight();
                var cheight = jQuery(".tui-grid-body-container").innerHeight();
                var diff = cheight - (height + scrollTop);
                if (diff > 40 && component.showBufferButton) {
                    component.refreshGrid(false);
                }
            });
        }
    }

    async updateGridCheckbox() {
        var allData = this.researchGrid.getData();
        for (var i = 0; i < allData.length; i++) {
            const rowData = allData[i];
            var exist = this.researchCards.findIndex(a => a.id == rowData.id);
            if (exist > -1) {
                this.researchGrid.check(rowData.rowKey.toString());
            }
        }
    }

    updateResearchCardOnCheck(rowData, isAdd) {
        var allData = this.researchGrid.getData();
        for (var i = 0; i < allData.length; i++) {
            var rowKey = allData[i].rowKey;
            if (rowKey == rowData["rowKey"]) {
                this.fnUpdateCardUsingID(allData[i].id, isAdd);
            }
        }
    }

    fnUpdateCardUsingID(recordId, isAdd) {
        let exist = this.researchCards.findIndex(a => a.id == recordId);
        if (isAdd) {
            if (exist < 0) {
                let card = this.researchData.find(a => a.id == recordId);
                this.researchCards.push({
                    id: card.id,
                    title: card.title,
                    title_de: card.title_de,
                    date: card.date,
                    url: card.url,
                    abstract: card.abstract,
                    chemicals: card.chemicals,
                    keywords: card.keywords,
                    mesh_terms: card.mesh_terms,
                    publication_types: card.publication_types
                });
            }
        } else {
            this.researchCards.splice(exist, 1);
        }
    }

    async fnStatisticsChart() {
        this.cd.detectChanges();
        await delay(1);

        let records: any[] = [];
        switch (this.selectedTab) {
            case TabsEnum.RESULTS:
                records = [...this.getFilteredData(this.allResearchData)]
                break;
            case TabsEnum.SELECTED:
                records = [...this.researchCards]
                break;
            default:
                break;
        }
        this.fnDisplayBarChart(records);
    }

    getTooltipContent(data) {
        return `${data.category}\nValue:\r${data.value}`;
    }

    fnDisplayBarChart(records: any) {
        this.keywordChartData = [];
        this.publicationChartData = [];

        if (!records || records.length <= 0) {
            return;
        }

        let keywordChartData = {};
        let publicationChartData = {};
        records.forEach(item => {
            if (item.keywords) {
                item.keywords.forEach(keyword => {
                    keywordChartData[keyword] = keywordChartData[keyword] ? keywordChartData[keyword] + 1 : 1;
                })
            }
            if (item.mesh_terms) {
                item.mesh_terms.forEach(term => {
                    keywordChartData[term] = keywordChartData[term] ? keywordChartData[term] + 1 : 1;
                })
            }
            if (item.publication_types) {
                item.publication_types.forEach(pub_type => {
                    publicationChartData[pub_type] = publicationChartData[pub_type] ? publicationChartData[pub_type] + 1 : 1;
                })
            }
        })

        var keywordChartDataArr = [];
        for (var key in keywordChartData) {
            keywordChartDataArr.push([key, keywordChartData[key]]);
        }
        keywordChartDataArr.sort(function (a, b) { return a[1] - b[1] });
        keywordChartDataArr.reverse();

        var publicationChartDataArr = [];
        for (var key in publicationChartData) {
            publicationChartDataArr.push([key, publicationChartData[key]]);
        }
        publicationChartDataArr.sort(function (a, b) { return a[1] - b[1] });
        publicationChartDataArr.reverse();

        const kMaxValue = keywordChartDataArr[0][1];
        for (var i = 0; i < keywordChartDataArr.length; i++) {
            var value = keywordChartDataArr[i][1];
            var percentage = Math.ceil((value / kMaxValue) * 100);
            var obj = {
                category: keywordChartDataArr[i][0],
                value: value,
                percentage: percentage
            }
            this.keywordChartData.push(obj);
        }


        const pMaxValue = publicationChartDataArr[0][1];
        for (var i = 0; i < publicationChartDataArr.length; i++) {
            var value = publicationChartDataArr[i][1];
            var percentage = Math.ceil((value / pMaxValue) * 100);
            var obj = {
                category: publicationChartDataArr[i][0],
                value: value,
                percentage: percentage
            }
            this.publicationChartData.push(obj);
        }
    }

    onLoad() {
        $("#research-file-input").click();
    }

    handelResearchFile(e) {
        var files = e.target.files;
        if (files.length < 1) {
            alert('Please Select a file...');
            return;
        }
        var file = files[0];
        var reader = new FileReader();
        reader.onload = this.onFileLoad.bind(this);
        reader.readAsText(file);
    }

    onFileLoad(e) {
        var jsonObj = JSON.parse(e.target.result);
        $("#research-file-input").val('');
        if (jsonObj.queryName) {
            this.queryName = jsonObj.queryName;
            this.fnUpdateJsPanelTitle();
        }
        if (jsonObj.searchQuery) {
            this.searchQuery = jsonObj.searchQuery;
        }
        if (jsonObj.cards) {
            this.researchCards = jsonObj.cards;
        }
        this.updateGridCheckbox();
        this.cd.detectChanges();
    }

    onDownload() {
        var jsonObj = {
            queryName: this.queryName,
            searchQuery: this.searchQuery,
            cards: this.researchCards
        }
        this.sharedService.downloadJSONFile("research_document", jsonObj);
    }
}
